import { WIDGET_CSS } from './widget-css.js';

const STYLE_ELEMENT_ID = 'aqua-dealer-widget-styles';

/**
 * Inject the compact-widget stylesheet (generated from
 * styles/panels/compact-voice-widget.css) into the document once — every
 * host, iframe app included, gets the pill CSS this way. Idempotent — safe
 * to call from every widget instance.
 */
export function ensureWidgetStyles(doc: Document = document): void {
  if (doc.getElementById(STYLE_ELEMENT_ID)) return;
  const style = doc.createElement('style');
  style.id = STYLE_ELEMENT_ID;
  style.textContent = WIDGET_CSS;
  doc.head.appendChild(style);
}
